module.exports = __webpack_public_path__ + "static/media/swapArrow.b8ec8a4f.svg";